// Warning banner for stock the plan cannot see: locations present in the
// inventory feed but missing from the atomic master. Hidden when the check
// passes; muted single line when the inputs are unreadable.
import { useState } from "react";
import { DroppedLocationCheck } from "./data_quality";
import { un, useSnapshotTokens } from "./primitives";

export const CoverageBanner = ({ check }: { check: DroppedLocationCheck }) => {
  const t = useSnapshotTokens();
  const [expanded, setExpanded] = useState(false);
  if (check.loading || check.unavailable || !check.dropped.length) {
    return null;
  }
  const shown = expanded ? check.dropped : check.dropped.slice(0, 4);
  return (
    <div
      style={{
        border: `1px solid ${t.orangeInk}55`,
        background: t.orange1,
        borderRadius: 8,
        padding: "10px 14px",
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <span style={{ fontSize: 12.5, fontWeight: 700, color: t.orangeInk }}>
          {check.dropped.length}{" "}
          {check.dropped.length === 1 ? "location" : "locations"} dropped from
          the atomic master
        </span>
        <span style={{ fontSize: 12, color: t.ink3 }}>
          {un(check.totalUnits)} on-hand units in the inventory feed are
          invisible to this plan — nothing below counts them.
        </span>
      </div>
      <div
        style={{
          display: "flex",
          gap: 14,
          flexWrap: "wrap",
          alignItems: "baseline",
        }}
      >
        {shown.map((d) => (
          <span
            key={d.location}
            title={`${d.skus} SKU rows at ${d.location} are not in the atomic master`}
            style={{ fontSize: 11.5, color: t.ink2, whiteSpace: "nowrap" }}
          >
            <b style={{ fontWeight: 600 }}>{d.location}</b>
            <span style={{ color: t.ink4 }}> · {un(d.units)} u</span>
          </span>
        ))}
        {check.dropped.length > 4 && (
          <span
            role="button"
            tabIndex={0}
            onClick={() => setExpanded(!expanded)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setExpanded(!expanded);
              }
            }}
            style={{
              fontSize: 11.5,
              fontWeight: 600,
              color: t.orangeInk,
              cursor: "pointer",
            }}
          >
            {expanded ? "Show less" : `+${check.dropped.length - 4} more`}
          </span>
        )}
      </div>
    </div>
  );
};
